import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewImportaWC = () => import('./index.vue')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'importa_wc',
        name: 'Importar Tropas/RFID',
        component: ViewImportaWC,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router